  <div class="modal-overlay p-2" >
    <div class="modal-content">
      <form (ngSubmit)="onSubmit()">
        <div class="modal-header">
          <h6 class="modal-title">Update User</h6>
          <button
            type="button"
            class="btn-close"
            (click)="closeModalFromInside()"></button>
        </div>

        <!-- Content -->
        <div class="modal-body">
          <div class="">
            <label for="fullName" class="form-label"
              ><strong>Full Name:</strong> Lamonte Scott</label
            >
          </div>
          <div class="mb-3">
            <label for="username" class="form-label"
              ><strong>Username:</strong> @lamontescott</label
            >
          </div>
          <div class="mb-3">
            <label class="form-label">Roles</label>
             <p-select
              [options]="[{id: 1, role: 'cat'}, {id: 1, role: 'dog'}]"
              [(ngModel)]="currentApp.role"
              name="selectedApp"
              optionLabel="role"
              optionValue="id" 
              placeholder="Select an app"
              [style]="{ width: '100%' }"
              class="w-full"
            ></p-select>
          </div>
             <div class="mb-3">
            <label class="form-label">Status</label>
             <p-select
              [options]="[{id: 1, role: 'cat'}, {id: 1, role: 'dog'}]"
              [(ngModel)]="currentApp.role"
              name="selectedApp"
              optionLabel="role"
              optionValue="id" 
              placeholder="Select an app"
              [style]="{ width: '100%' }"
              class="w-full"
            ></p-select>
          </div>
        </div>

        <!-- Control Btns -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeModalFromInside()">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!myForm.valid">
            Update App
          </button>
        </div>
      </form>
    </div>
  </div>
